import { render, staticRenderFns } from "./topic-list-index.vue?vue&type=template&id=115b0c58&scoped=true"
import script from "./topic-list-index.vue?vue&type=script&lang=js"
export * from "./topic-list-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b0c58",
  null
  
)

export default component.exports